/**
 * Property-photo URL normaliser for the admin frontend.
 *
 * Older properties were imported with photo URLs prefixed by FRONTEND_URL,
 * which at the time defaulted to http://localhost:8080. Those URLs literally
 * point at a developer machine and 404 from any deployed browser, AND get
 * blocked as mixed content (http on https admin). The marketing site has the
 * same helper at web/lib/queries.ts (fixPhotoUrl) which rewrites them to a
 * relative path served from /web/public/assets/media/.
 *
 * Admin runs on a different origin (app.oceanhome.es) so a relative rewrite
 * would resolve to the wrong host. Rewrite to the absolute marketing URL
 * instead. Override with REACT_APP_MARKETING_URL in env if needed.
 *
 * Data URIs and properly-shaped https URLs pass through untouched. New
 * photos uploaded after this fix use base64 data URIs so they never hit
 * the rewrite path.
 */
const MARKETING_URL = (
  process.env.REACT_APP_MARKETING_URL || 'https://www.oceanhome.es'
).replace(/\/$/, '');

export function fixPhotoUrl(url) {
  if (!url) return '';
  return url
    .replace(/^https?:\/\/localhost:\d+/, MARKETING_URL)
    .replace(/^https?:\/\/127\.0\.0\.1:\d+/, MARKETING_URL);
}
